import React from 'react';
import { Link } from '@remix-run/react';

import Logo from '~/components/Logo';
import { useLayoutStore } from '~/providers/layout-store-provider';

import { HeaderNavItem } from '../HeaderNavItem';

import styles from './SecondaryHeaderNavGroup.module.css';

const SecondaryHeaderNavGroup = () => {
  const links = useLayoutStore((s) => s.navData.secondLevelNav);
  const resourcesUrl = useLayoutStore((s) => s.resourcesUrl);

  return (
    <section className={styles.container}>
			<div className={styles.content}>
				<Link title="Oddschecker" to="">
					<div className={styles.logoWrapper}>
						<Logo resourcesUrl={resourcesUrl} />
					</div>
				</Link>
				<ul className={styles.links}>
					{links.map((link) =>
          <React.Fragment key={link.link}>
							<HeaderNavItem {...link} variant="secondary" />
						</React.Fragment>
          )}
				</ul>
			</div>
		</section>);

};

export { SecondaryHeaderNavGroup };